import React, { useContext, useEffect, useReducer, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import LoadingBox from '../../components/LoadingBox/LoadingBox.jsx';
import MessageBox from '../../components/MessageBox/MessageBox.jsx';
import { Store } from '../../Store';
import { getError, getStatus } from '../../utils';
import { toast } from 'react-toastify';
import GoBackBtn from '../../components/GoBackButton/GoBackBtn.jsx';
import './OrderScreen.css';
import moment from 'moment';
import { TbReceipt2 } from 'react-icons/tb';
import PermissionWrapper from '../../permission-utils/PermissionWrapper.jsx';
import { SCOPES } from '../../permission-utils/scopes.js';
import { Modal } from 'react-bootstrap';
import _orders from '../../services/order.service.js';
import _mercadopago from '../../services/mercadopago.service.js';
import _utils from '../../services/utils.service.js';	
import PaymentMethod from '../../models/PaymentMethod.js';

function reducer(state, action) {
	switch (action.type) {
	case 'FETCH_REQUEST':
		return { ...state, loading: true, error: '' };
	case 'FETCH_SUCCESS':
		return { ...state, loading: false, order: action.payload, error: '' };
	case 'FETCH_FAIL':
		return { ...state, loading: false, error: action.payload };
	case 'PAY_REQUEST':
		return { ...state, loadingPay: true };
	case 'PAY_SUCCESS':
		return { ...state, loadingPay: false, successPay: true };
	case 'PAY_FAIL':
		return { ...state, loadingPay: false };
	case 'CANCEL_PAY_REQUEST':
		return { ...state, loadingCancelPay: true };
	case 'CANCEL_PAY_SUCCESS':
		return { ...state, loadingCancelPay: false, successCancelPay: true };
	case 'CANCEL_PAY_FAIL':
		return { ...state, loadingCancelPay: false };
	case 'CANCEL_PAY_RESET':
		return { ...state, loadingCancelPay: false, successCancelPay: false };
	case 'PAY_RESET':
		return { ...state, loadingPay: false, successPay: false };
	case 'DELIVER_REQUEST':
		return { ...state, loadingDeliver: true };
	case 'DELIVER_SUCCESS':
		return { ...state, loadingDeliver: false, successDeliver: true };
	case 'DELIVER_FAIL':
		return { ...state, loadingDeliver: false };
	case 'DELIVER_RESET':
		return { ...state, loadingDeliver: false, successDeliver: false };
	case 'CANCEL_SUCCESS':
		return { ...state, successCancel: true };
	case 'CANCEL_RESET':
		return { ...state, successCancel: false};
	default:
		return state;
	}
}
function OrderScreen() {
	const { state, dispatch: ctxDispatch } = useContext(Store);
	const { userInfo } = state;
	const [preference, setPreference] = useState('');
	const [missingStock, setMissingStock] = useState('');
	const [showCancelOrderModal,setShowCancelOrderModal] = useState(false);
	const [paymentMethodData , setPaymentMethodData] = useState(PaymentMethod.createEmpty());
	const params = useParams();
	const { id: orderId } = params;
	const navigate = useNavigate();
	const redirect = () => {
		ctxDispatch({ type: 'USER_SIGNOUT' });
		navigate('/signin');
		toast.error('Sesion expirada. Vuelve a ingresar.');
	};
	const [
		{
			loading,
			error,
			order,
			successPay,
			successCancelPay,
			loadingPay,
			loadingDeliver,
			loadingCancelPay,
			successDeliver,
			successCancel
		},
		dispatch,
	] = useReducer(reducer, {
		loading: true,
		order: {},
		error: '',
		successPay: false,
		successCancelPay: false,
		loadingPay: false,
		loadingDeliver: false,
		loadingCancelPay: false,
		successDeliver: false,
		successCancel: false
	});
	//#region REQUESTS
	const fetchOrder = async () => {
		try {
			dispatch({ type: 'FETCH_REQUEST' });
			const { data } = await _orders.get(orderId);
			dispatch({ type: 'FETCH_SUCCESS', payload: data });
		} catch (err) {
			dispatch({ type: 'FETCH_FAIL', payload: getError(err) });
			console.error(getError(err));
			toast.error(getError(err));
		}
	};
	//TODO (idea): cambiar metodo como string por referencia para
	//no sea necesario esto
	const fetchPaymentMethodData = async () => {
		try {
			const {data} = await _utils.getPaymentMethod(order.paymentMethod);
			setPaymentMethodData(PaymentMethod.create(data));
		} catch(ex) {
			console.error(ex);
		}
	};
	async function payOrderHandler() {
		try {
			dispatch({ type: 'PAY_REQUEST' });
			const { data } = await _orders.setAsPaid(orderId);
			dispatch({ type: 'PAY_SUCCESS', payload: data });
			toast.success('Pedido Pago');
		} catch (err) {
			dispatch({ type: 'PAY_FAIL', payload: getError(err) });
			toast.error(getError(err));
		}
	}
	async function deliverOrderHandler() {
		try {
			const { data } = await _orders.setAsDelivered(orderId);
			dispatch({ type: 'DELIVER_SUCCESS', payload: data });
			toast.success('Pedido confirmado');
		} catch (err) {
			dispatch({ type: 'DELIVER_FAIL', payload: getError(err) });
			if (getStatus(err) == 400 && err.response.data.missingStock) {
				setMissingStock(err.response.data.missingStock);
			} else {
				toast.error(getError(err));
			}
		}
	}
	const payMpOrderHandler = async () => {
		try {
			dispatch({ type: 'PAY_REQUEST' });
			const { data } = await _orders.setMercadoPagoStatusAsPaid(orderId);
			dispatch({ type: 'PAY_SUCCESS', payload: data });
			toast.success('Pedido Pago');
		} catch (err) {
			dispatch({ type: 'PAY_FAIL', payload: getError(err) });
			toast.error(getError(err));
		}
	};
	const cancelOrderHandler = async() => {
		try {
			await _orders.cancel(orderId);
			dispatch({type: 'CANCEL_SUCCESS'});
			toast.success('Pedido cancelado');
		}catch(ex) {
			toast.error('No se pudo cancelar la orden');
			console.error(ex);
		}
		setShowCancelOrderModal(false);
	};
	const fetchMercadoPagoPreference = async () => {
		try {
			const { data } = await _mercadopago.createPreference(order._id, window.location.origin);
			if (data) {
				setPreference(data);
			}
		} catch (ex) {
			console.error(ex);
		}
	};

	const handleMpCheckout = async () => {
		const checkout = preference.init_point;
		try {
			await _mercadopago.createTransaction(order._id, preference.id);
			await _orders.setMercadoPagoStatusAsPending(order._id);
			window.location.href = checkout;
		} catch (ex) {
			console.error(ex);
		}
	};

	const handleCancelPayment = async () => {
		try {
			dispatch({ type: 'CANCEL_PAY_REQUEST' });

			const {data} = await _orders.cancelPayment(orderId);
			dispatch({ type: 'CANCEL_PAY_SUCCESS', payload: data });
			toast.success('Pago Anulado');
		} catch (error) {
			dispatch({ type: 'CANCEL_PAY_FAIL', payload: getError(error) });
			toast.error(getError(error));
		}
	};
	//#endregion 


	useEffect(() => {
		if (
			!order._id ||
      successPay ||
      successDeliver ||
      successCancel || 
      successCancelPay || 
      (order._id && order._id !== orderId)
		) {
			fetchOrder();

			if (successPay) {
				dispatch({ type: 'PAY_RESET' });
			}
			if (successDeliver) {
				dispatch({ type: 'DELIVER_RESET' });
			}
			if(successCancel) {
				dispatch({ type: 'CANCEL_RESET' });
			}
			if(successCancelPay) {
				dispatch({ type: 'CANCEL_PAY_RESET' });
			}
		}
		if(order && !paymentMethodData.method) {
			fetchPaymentMethodData();
		}
	}, [order, userInfo, orderId, successPay, successDeliver, successCancel, successCancelPay]);
	useEffect(() => {
		if(Object.keys(order).length  &&  order.user._id != userInfo._id && userInfo.role === 'client') {
			navigate('/');
		}
		if (Object.keys(order).length && !preference) {
			if (
				!order.isPaid &&
				(order.paymentMethod.toLowerCase() === 'mercadopago' || order.paymentMethod.toLowerCase() === 'mercadopagocuotas')
			) {
				fetchMercadoPagoPreference();
			}
		}
	}, [order]);


	async function verComprobante(proofOfPayment) {
		if (proofOfPayment) {
			window.open(proofOfPayment.fileLink, '_blank', 'noopener,noreferrer');
		}

	}
	/**
	 *  @param {string} date
	 * @param {boolean} withTime
	 */
	const formatDateString = (date = '', withTime) => {
		return typeof date == 'string' ? `${date.substring(0, 10)} ${withTime ? date.substring(11, 16) : ''}` : '';
	};

	return loading ? (
		<LoadingBox></LoadingBox>
	) : error ? (
		<MessageBox variant="danger">{error}</MessageBox>
	) : (
		<div>
			<Modal
				show={showCancelOrderModal}
				centered
				onHide={() => setShowCancelOrderModal(false)}
				dialogClassName="cancel-order-modal"
			>
				<Modal.Body >
					<p className="text-center">
                ¿Seguro quieres cancelar el pedido?
					</p></Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button variant="primary"
						onClick={() => setShowCancelOrderModal(false)}>
                Atrás
					</Button>
					<Button variant="primary" onClick={cancelOrderHandler}>
                Confirmar
					</Button>
				</Modal.Footer>
			</Modal>
			<Helmet>
				<title>{`Orden ${order.internalId}`}</title>
			</Helmet>
			<h1 className="my-3">Pedido Preparado: {order.internalId}</h1>
			<Row>
				<Col md={8}>
					<Card className="mb-3">
						<Card.Body>
							<Card.Title>
								{order.shippingAddress ? 'Envío' : 'Estado'}
							</Card.Title>
							{order.shippingAddress && (
								<Card.Text>
									<div>
										{' '}
										<strong>Nombre:</strong> {order.shippingAddress.fullName}{' '}
										<br />
										<strong>Localidad:</strong>{' '}
										{order.shippingAddress.country || ''},
										{order.shippingAddress.state || ''},
										{order.shippingAddress.city}
										<br />
										<strong>Direccion: </strong>
										{order.shippingAddress.address},
										{order.shippingAddress.streetCorner}
									</div>
									<strong>Telefono:</strong> {order.shippingAddress.telephone}
									<br />
									<strong>Horario de Preferencia:</strong>
									{order.shippingAddress.timeForDelivery}
									<br />
									<strong>Fecha de preferencia:</strong>
									{moment(order.shippingAddress.shippingDate).isValid()
										? moment(order.shippingAddress.shippingDate).format(
											'DD/MM/YY'
										)
										: order.shippingAddress.shippingDate}
									<br />
									<strong>Comentarios:</strong> {order.shippingAddress.comments}
								</Card.Text>
							)}
							{
								order.active ?
									(
										order.isDelivered || order.confirmedBy ?
											<MessageBox variant="success">
														Confirmado {userInfo?.role !== 'client' && `por ${order?.confirmedBy?.name || 'el sistema'} `}
												{formatDateString(order.deliveredAt, true)}
											</MessageBox> :
											<MessageBox cols = "10" variant="info">
												{paymentMethodData.usesPaymentGateway ?
													`No podemos procesar su pago en este momento, algunos articulos de su pedido requiren confirmacion de la tienda.
													Una vez confirmado podra completar su pago web`
													:
													'Pendiente de aprobación. Estamos verificando la disponibilidad de los artículos.'
												}
											</MessageBox>
									)
									: <MessageBox variant="danger">
												Pedido cancelado {(userInfo.role !== 'client' && order.cancelledBy)
													&& `por ${order.cancelledBy.name}`}: <br />
										{formatDateString(order.cancelledAt, true)}
									</MessageBox>
							}
						</Card.Body>
					</Card>
					<Card className="mb-3">
						<Card.Body>
							<Card.Title>Pago</Card.Title>
							<Card.Text>
								<strong>Metodo:</strong>
								{order.paymentMethod}
								{order.proofOfPayment ? (
									<>
										<br />
										<strong>Comprobante:</strong>
										<Button
											variant="outline-success"
											className=" mx-2"
											onClick={() => {
												verComprobante(order.proofOfPayment);
											}}
										>
											<TbReceipt2 />
										</Button>
									</>
								) : null}
								<PermissionWrapper fn={'orders'} scopes={[SCOPES.canView]}>
									{
										order.paymentMethod.toLowerCase() !== 'mercadopago' &&
										order.paymentMethod.toLowerCase() !== 'mercadopagocuotas'? (
												<>
													{order.isPaid ? (
														<MessageBox variant="success">
																	Pago el: {formatDateString(order.paidAt, false)}
														</MessageBox>
													) : (
														<MessageBox variant="danger">No Pago</MessageBox>
													)}
												</>
											) : 
											(order.mercadoPagoStatus === 'approved' ? (
												<MessageBox variant="success">
															Pago {order.paidAt && `el: ${formatDateString(order.paidAt, false) }`}
												</MessageBox>
											) : order.mercadoPagoStatus === 'pending' ? (
												<MessageBox variant="warning">
															Pago pendiente.
													{order.paidAt && `Transaccion comenzada el ${formatDateString(order.paidAt, true) }`}
												</MessageBox>
											) : (
												<MessageBox variant="danger">No pago</MessageBox>
											))
											
									}
								</PermissionWrapper>
							</Card.Text>
						</Card.Body>
					</Card>
					{order.seller || !order.seller ? (
						<Card className="mb-3">
							<Card.Body>
								<Card.Title>Comentarios</Card.Title>
								<Card.Text>
               
									{order.seller}
								</Card.Text>
							</Card.Body>
						</Card>
					) : null}
                  
					<Card className="mb-3">
						<Card.Body>
							<Card.Title>Items</Card.Title>
							<ListGroup variant="flush">
								{order.orderItems.map((item) => (
									<ListGroup.Item key={item._id}>
										<Row className="align-items-center">
											<Col md={4}>
												{item.image && typeof item.image === 'object' ? (
													<img
														src={item.image.fileLink}
														alt={item.name}
														className="img-fluid rounded img-thumbnail"
													></img>
												) : (
													<img
														alt="product_photo"
														src="/images/emptyPhoto.png"
														className="img-fluid rounded img-thumbnail"
													/>
												)}
												<Link to={`/product/${encodeURIComponent(item.slug)}`}>{item.name}</Link>
											</Col>
											<Col md = {2}>
												{item.variant ? item.options.map((opt) => (
													<div>{`${opt.option}: ${opt.value}`}</div>
												)) :
													<div className="text-center">
                            N/A
													</div>
												}
											</Col>
											<Col md={2}>
												<span>Cant: {item.quantity}</span>{' '}
											</Col>
											<Col md={2}>Precio: ${item.price}</Col>
											<Col md={2}>Total: ${item.price * item.quantity}</Col>
										</Row>
									</ListGroup.Item>
								))}
							</ListGroup>
						</Card.Body>
					</Card>
				</Col>
				<Col md={4}>
					<Card>
						<Card.Body>
							<Card.Title>Usuario</Card.Title>
							<div>
								<strong>Nombre:</strong> {order.user.name} <br />
								<strong>Email:</strong> {order.user.email} <br />
							</div>
						</Card.Body>
					</Card>
					{/* <Card.Body>
           */}
					<Card className="mb-3">
						<Card.Body>
							<Card.Title>Resumen</Card.Title>
							<ListGroup variant="flush">
								<ListGroup.Item>
									<Row>
										<Col>Subtotal</Col>
										<Col>${order.subtotalPrice?.toFixed(2)}</Col>
									</Row>
									{order.discountCoupon && order.subtotalPrice && order.discountCoupon.discountPercent && (
										<Row>
											<Col>Descuento ({order.discountCoupon.discountPercent}%)</Col>
											<Col>-${(order.discountedAmount)}</Col>
										</Row>
									)}
									{order.paymentMethod && (
										<Row>
											<Col>{order.paymentMethod}</Col>
											<Col>${order.paymentMethodChargedAmount || 0}</Col>
										</Row>
									)}
							
								</ListGroup.Item>
								<ListGroup.Item>
									<Row>
										<Col>
											<strong>Total Pedido</strong>
										</Col>
										<Col>
											<strong>
                        ${order.totalPrice.toFixed(2)}
											</strong>
										</Col>
									</Row>
								</ListGroup.Item>
								<PermissionWrapper fn="orders" field="paid" scopes={[SCOPES.canEdit]}>
									{ !order.isPaid && order.active &&
                  order.mercadoPagoStatus !== 'approved' && (
										<ListGroup.Item>
											{loadingPay && <LoadingBox></LoadingBox>}
											<div className="d-grid">
												<button
													className="btn-outline-warning btn light"
													onClick={
														order.paymentMethod.toLowerCase() == 'mercadopago' || order.paymentMethod.toLowerCase() == 'mercadopagocuotas'
															? payMpOrderHandler
															: payOrderHandler
													}
												>
                          Confirmar Pago
												</button>
											</div>
										</ListGroup.Item>
									)}
									{ order.isPaid && order.active && (
										<ListGroup.Item>
											{loadingCancelPay && <LoadingBox></LoadingBox>}
											<div className="d-grid">
												<button
													className="btn-outline-danger btn light"
													onClick={handleCancelPayment}
												>
                          Anular Pago
												</button>
											</div>
										</ListGroup.Item>
									)}

								</PermissionWrapper>
								<PermissionWrapper fn="orders" field="deliver" scopes={[SCOPES.canEdit]}>
									{ !order.isDelivered && order.active && !order.confirmedBy && (
										<ListGroup.Item>
											<div className="d-grid">
												<button
													className="btn-outline-warning btn light"
													onClick={deliverOrderHandler}
												>
                          Confirmar Pedido
												</button>
											</div>
										</ListGroup.Item>
									)}
								</PermissionWrapper>
								{order.mercadoPagoStatus !== 'approved' &&
                  (order.paymentMethod.toLowerCase() === 'mercadopago' || order.paymentMethod.toLowerCase() == 'mercadopagocuotas') && (
									<ListGroup.Item>
										<div className="d-grid">
											<button
												className="btn mp"
												disabled={!order.isDelivered || !preference}
												onClick={handleMpCheckout}
											>
                          Pagar
												<svg
													id="mp-logo"
													xmlns="http://www.w3.org/2000/svg"
													role="img"
													viewBox="0 0 24 24"
												>
													<title>Mercado Pago</title>
													<path d="M11.115 16.479a.93.927 0 0 1-.939-.886c-.002-.042-.006-.155-.103-.155-.04 0-.074.023-.113.059-.112.103-.254.206-.46.206a.816.814 0 0 1-.305-.066c-.535-.214-.542-.578-.521-.725.006-.038.007-.08-.02-.11l-.032-.03h-.034c-.027 0-.055.012-.093.039a.788.786 0 0 1-.454.16.7.699 0 0 1-.253-.05c-.708-.27-.65-.928-.617-1.126.005-.041-.005-.072-.03-.092l-.05-.04-.047.043a.728.726 0 0 1-.505.203.73.728 0 0 1-.732-.725c0-.4.328-.722.732-.722.364 0 .675.27.721.63l.026.195.11-.165c.01-.018.307-.46.852-.46.102 0 .21.016.316.05.434.13.508.52.519.68.008.094.075.1.09.1.037 0 .064-.024.083-.045a.746.744 0 0 1 .54-.225c.128 0 .263.03.402.09.69.293.379 1.158.374 1.167-.058.144-.061.207-.005.244l.027.013h.02c.03 0 .07-.014.134-.035.093-.032.235-.08.367-.08a.944.942 0 0 1 .94.93.936.934 0 0 1-.94.928zm7.302-4.171c-1.138-.98-3.768-3.24-4.481-3.77-.406-.302-.685-.462-.928-.533a1.559 1.554 0 0 0-.456-.07c-.182 0-.376.032-.58.095-.46.145-.918.505-1.362.854l-.023.018c-.414.324-.84.66-1.164.73a1.986 1.98 0 0 1-.43.049c-.362 0-.687-.104-.81-.258-.02-.025-.007-.066.04-.125l.008-.008 1-1.067c.783-.774 1.525-1.506 3.23-1.545h.085c1.062 0 2.12.469 2.24.524a7.03 7.03 0 0 0 3.056.724c1.076 0 2.188-.263 3.354-.795a9.135 9.11 0 0 0-.405-.317c-1.025.44-2.003.66-2.946.66-.962 0-1.925-.229-2.858-.68-.05-.022-1.22-.567-2.44-.57-.032 0-.065 0-.096.002-1.434.033-2.24.536-2.782.976-.528.013-.982.138-1.388.25-.361.1-.673.186-.979.185-.125 0-.35-.01-.37-.012-.35-.01-2.115-.437-3.518-.962-.143.1-.28.203-.415.31 1.466.593 3.25 1.053 3.812 1.089.157.01.323.027.491.027.372 0 .744-.103 1.104-.203.213-.059.446-.123.692-.17l-.196.194-1.017 1.087c-.08.08-.254.294-.14.557a.705.703 0 0 0 .268.292c.243.162.677.27 1.08.271.152 0 .297-.015.43-.044.427-.095.874-.448 1.349-.82.377-.296.913-.672 1.323-.782a1.494 1.49 0 0 1 .37-.05.611.61 0 0 1 .095.005c.27.034.533.125 1.003.472.835.62 4.531 3.815 4.566 3.846.002.002.238.203.22.537-.007.186-.11.352-.294.466a.902.9 0 0 1-.484.15.804.802 0 0 1-.428-.124c-.014-.01-1.28-1.157-1.746-1.543-.074-.06-.146-.115-.22-.115a.122.122 0 0 0-.096.045c-.073.09.01.212.105.294l1.48 1.47c.002 0 .184.17.204.395.012.244-.106.447-.35.606a.957.955 0 0 1-.526.171.766.764 0 0 1-.42-.127l-.214-.206a21.035 20.978 0 0 0-1.08-1.009c-.072-.058-.148-.112-.221-.112a.127.127 0 0 0-.094.038c-.033.037-.056.103.028.212a.698.696 0 0 0 .075.083l1.078 1.198c.01.01.222.26.024.511l-.038.048a1.18 1.178 0 0 1-.1.096c-.184.15-.43.164-.527.164a.8.798 0 0 1-.147-.012c-.106-.018-.178-.048-.212-.089l-.013-.013c-.06-.06-.602-.609-1.054-.98-.059-.05-.133-.11-.21-.11a.128.128 0 0 0-.096.042c-.09.096.044.24.1.293l.92 1.003a.204.204 0 0 1-.033.062c-.033.044-.144.155-.479.196a.91.907 0 0 1-.122.007c-.345 0-.712-.164-.902-.264a1.343 1.34 0 0 0 .13-.576 1.368 1.365 0 0 0-1.42-1.357c.024-.342-.025-.99-.697-1.274a1.455 1.452 0 0 0-.575-.125c-.146 0-.287.025-.42.075a1.153 1.15 0 0 0-.671-.564 1.52 1.515 0 0 0-.494-.085c-.28 0-.537.08-.767.242a1.168 1.165 0 0 0-.903-.43 1.173 1.17 0 0 0-.82.335c-.287-.217-1.425-.93-4.467-1.613a17.39 17.344 0 0 1-.692-.189 4.822 4.82 0 0 0-.077.494l.67.157c3.108.682 4.136 1.391 4.309 1.525a1.145 1.142 0 0 0-.09.442 1.16 1.158 0 0 0 1.378 1.132c.096.467.406.821.879 1.003a1.165 1.162 0 0 0 .415.08c.09 0 .179-.012.266-.034.086.22.282.493.722.668a1.233 1.23 0 0 0 .457.094c.122 0 .241-.022.355-.063a1.373 1.37 0 0 0 1.269.841c.37.002.726-.147.985-.41.221.121.688.341 1.163.341.06 0 .118-.002.175-.01.47-.059.689-.24.789-.382a.571.57 0 0 0 .048-.078c.11.032.234.058.373.058.255 0 .501-.086.75-.265.244-.174.418-.424.444-.637v-.01c.083.017.167.026.251.026.265 0 .527-.082.773-.242.48-.31.562-.715.554-.98a1.28 1.279 0 0 0 .978-.194 1.04 1.04 0 0 0 .502-.808 1.088 1.085 0 0 0-.16-.653c.804-.342 2.636-1.003 4.795-1.483a4.734 4.721 0 0 0-.067-.492 27.742 27.667 0 0 0-5.049 1.62zm5.123-.763c0 4.027-5.166 7.293-11.537 7.293-6.372 0-11.538-3.266-11.538-7.293 0-4.028 5.165-7.293 11.539-7.293 6.371 0 11.537 3.265 11.537 7.293zm.46.004c0-4.272-5.374-7.755-12-7.755S.002 7.277.002 11.55L0 12.004c0 4.533 4.695 8.203 11.999 8.203 7.347 0 12-3.67 12-8.204z" />
												</svg>
											</button>
										</div>
									</ListGroup.Item>
								)}
								<PermissionWrapper fn="orders" field="cancel" scopes={[SCOPES.canEdit]}>
									{order.active && (
										<ListGroup.Item>
											<div className="d-grid">
												<button
													className="btn-outline-danger btn light"
													onClick={() => setShowCancelOrderModal(true)}
												>
                              Cancelar Pedido
												</button>
											</div>
										</ListGroup.Item>
									)}
								</PermissionWrapper>
							</ListGroup>
						</Card.Body>
					</Card>
					{missingStock && (
						<Card className="mb-3">
							<Card.Body>
								<MessageBox variant="danger" cols={12}>
									{missingStock.map((msg) => {
										return (
											<>
												{msg} <br />{' '}
											</>
										);
									})}
								</MessageBox>
							</Card.Body>
						</Card>
					)}
					<PermissionWrapper fn={'orders'} scopes={[SCOPES.canView]}>
						<GoBackBtn/>
					</PermissionWrapper>
				</Col>
			</Row>
		</div>
	);
}

export default OrderScreen;
